import type { ConfluenceComment } from '../../types';

export const isConfluenceComment = (entity: any): entity is ConfluenceComment =>
	entity.__typename === 'ConfluenceComment';

export const getConfluenceCommentLink = (comment: ConfluenceComment): string | null => {
	const { base, webUi } = comment.links ?? {};

	if (base === undefined || webUi === undefined || base.length === 0 || webUi.length === 0) {
		return null;
	}

	return `${base}${webUi}`;
};
